import Calendar from "components/common/Calendar";
import { motion } from "framer-motion";
import { Card, Col, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import moment from "moment"; // Recommended: use moment instead of manual parsing

const ClaimProviderServices = () => {
  const { viewClaimInfo } = useSelector((state) => state.claim);

  const claimServicesList = viewClaimInfo?.service_procedures || [];


  const diagnosis = viewClaimInfo?.payload_json?.diag || [];

  // Helper to safely format date from YYYY-MM-DD
  const formatServiceDate = (dateStr) => {
    if (!dateStr || !/^\d{4}-\d{2}-\d{2}$/.test(dateStr))
      return { day: "", month: "", year: "" };

    const date = moment(dateStr, "YYYY-MM-DD");
    if (!date.isValid()) return { day: "", month: "", year: "" };

    console.log({ date: date.format("DD") });

    return {
      day: date.format("DD"),
      month: date.format("MMM"),
      year: date.format("YYYY"),
    };
  };

  return (
    <motion.div
      style={{ border: "2px solid #d9f8eb" }}
      className="rounded p-3 position-relative mt-3 mb-3"
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: 50 }}
      transition={{ duration: 0.5 }}
    >
      <div className="position-absolute top-0 start-45 translate-middle-y px-2">
        <span className="badge shadow-sm d-flex align-items-center justify-content-center gap-2 badge-subtle-success">
          <span className="fs-10">Service & Procedures</span>
        </span>
      </div>

      <Row className="mt-4">
        {claimServicesList.map((item, index) => {
          const grossAmt = Number(item?.servinfo_prdpri) * Number(item?.servinfo_prdqty);

          const discountAmt = (Number(item?.servinfo_prddisc || 0) / 100) * grossAmt;

          const diagInfo = null;
          const { day, month, year } = formatServiceDate(item?.dateserv);

          console.log({ day, month, year });


          const medReq = item.medication_request || {};
          const dosage = medReq.dosage_instruction || {};

          const hasPrescriptionDetails = Boolean(
            item.pres_med ||
            item.medication_request ||
            item.pselrsn ||
            item.pharslrsn ||
            item.pharsubs ||
            item.strngth ||
            item.pharstrnth ||
            item.pharsubsrsn ||
            item.pharsubs_oth ||
            item?.absenceRsn ||
            item?.pharscabrsn ||
            item?.pharscabrsn_oth ||
            item?.duration ||
            dosage?.duration ||
            item?.frequency ||
            dosage?.frequency ||
            item?.dose ||
            dosage?.dose ||
            item?.dosage_instruction ||
            dosage?.text ||
            item?.refill_count ||
            dosage?.refill ||
            item?.pat_inst ||
            dosage?.patient_instruction ||
            item?.time_inst_disp ||
            dosage?.time_instruction_desc ||
            item?.ROA_disp ||
            dosage?.route_desc
          );

          const durationDisplay =
            dosage.duration ||
            (item.duration
              ? `${item.duration.dur_time || ""} ${item.duration.dur_time_value || ""
              }`
              : "");
          const frequencyDisplay =
            dosage.frequency ||
            (item.frequency
              ? `${item.frequency.frq || ""} - ${item.frequency.frq_prd || "0"
              } ${item.frequency.frq_time_value || ""}`
              : "");
          const doseDisplay =
            dosage.dose ||
            (item.dose
              ? `${item.dose.dsg_time_value} ${item.dose.dsg_inst}`
              : "");
          const routeDisplay = dosage.route_desc || item.ROA_disp;
          const timeInstDisplay =
            dosage.time_instruction_desc || item.time_inst_disp;
          const refillDisplay = dosage.refill || item.refill_count;
          const dosageInstDisplay = dosage.text || item.dosage_instruction;
          const patientInstDisplay =
            dosage.patient_instruction || item.pat_inst;
          const periodDisplay =
            dosage.period_start && dosage.period_end
              ? `${dosage.period_start} - ${dosage.period_end}`
              : item.duration
                ? `${item.duration.start} - ${item.duration.end}`
                : "";

          const medCode =
            medReq.medicationrequest_code || item.pres_med?.type || "";
          const medDesc =
            medReq.medicationrequest_desc || item.claimMedicalDisplay || "";
          const strength = item.pharstrnth || item.strngth || "";
          const absenceCode =
            item.pharscabrsn || item.Sntfc_code_abs_rsn || "";
          const absenceOther = item.pharscabrsn_oth || "";
          const selectionReason = item.pharslrsn || item.pselrsn || "";
          const pharmacistSub = item.pharsubs || "";
          const pharmacistSubReason =
            item.pharsubs_oth || item.pharsubsrsn || "";

          return (
            <Col
              xs={12}
              key={`${item.itemcode}-${item.dateserv}-${index}`}
              className="mb-3"
            >
              <Card className="p-3 h-100 shadow-sm">
                <Row className="g-3">
                  <Col xs={12} md={2} className="text-center">
                    <div className="badge badge-subtle-success fs-10 mb-3">
                      {index + 1}
                    </div>
                    {item.dateserv && (
                      <div className="d-flex justify-content-center mt-2">
                        <Calendar month={month} day={day} year={year} />
                      </div>
                    )}
                  </Col>

                  <Col xs={12} md={10}>
                    <Row>
                      {/* Service Code & Description */}
                      <Col xs={12} className="mb-3">
                        <div className="d-flex flex-wrap gap-3 align-items-center">
                          <div>
                            <span className="badge badge-subtle-success me-2">
                              {item.itemcode}
                            </span>
                            <span className="fs-10 text-700">
                              {item?.itemdescp}
                            </span>
                          </div>
                          {item.itemlclcode && (
                            <div>
                              <span className="badge badge-subtle-warning me-2">
                                {item.itemlclcode}
                              </span>
                              <span className="fs-10 text-muted">
                                {item.itemlcldescp || item.internalDescription}
                              </span>
                            </div>
                          )}
                        </div>
                      </Col>

                      {/* Main Info Grid */}
                      <Col xs={12}>
                        <Row className="gy-2">
                          <Col xs={6} md={2}>
                            <div className="d-flex flex-column">
                              <span className="fs-10 fw-semibold">Type</span>
                              <span className="fs-10 text-600">
                                {item.prdtypcde}
                              </span>
                            </div>
                          </Col>
                          <Col xs={6} md={2}>
                            <div className="d-flex flex-column">
                              <span className="fs-10 text-800 fw-bold">
                                Unit Price
                              </span>
                              <span className="fs-10">{item.servinfo_prdpri}</span>
                            </div>
                          </Col>
                          <Col xs={6} md={2}>
                            <div className="d-flex flex-column">
                              <span className="fs-10 text-800 fw-bold">
                                Discount Amount
                              </span>
                              <span className="fs-10  ">{discountAmt}</span>
                            </div>
                          </Col>
                          <Col xs={6} md={2}>
                            <div className="d-flex flex-column">
                              <span className="fs-10 text-800 fw-bold">
                                Quantity
                              </span>
                              <span className="fs-10 text-600">
                                {item.servinfo_prdqty}
                              </span>
                            </div>
                          </Col>
                          <Col xs={6} md={2}>
                            <div className="d-flex flex-column">
                              <span className="fs-10 text-800 fw-bold">
                                Patient Share
                              </span>
                              <span className="fs-10 text-600 ">
                                {item.servinfo_prdpshre}
                              </span>
                            </div>
                          </Col>
                          <Col xs={6} md={2}>
                            <div className="d-flex flex-column">
                              <span className="fs-10 text-800 fw-bold">
                                Net Amount
                              </span>
                              <span className="fs-10  ">{item.servinfo_prdnamnt}</span>
                            </div>
                          </Col>
                          <Col xs={6} md={2}>
                            <div className="d-flex flex-column">
                              <span className="fs-10 text-800 fw-bold">
                                Tooth No
                              </span>
                              <span className="fs-10 fw-bold ">
                                {item.toothno || ""}
                              </span>
                            </div>
                          </Col>
                          <Col xs={6} md={2}>
                            <div className="d-flex flex-column">
                              <span className="fs-10 text-800 fw-bold">
                                Diagnosis
                              </span>
                              <span className="fs-10 text-600">
                                {item.servinfo_diagname || ""}
                              </span>
                            </div>
                          </Col>
                          <Col xs={6} md={2}>
                            <div className="d-flex flex-column">
                              <span className="fs-10 text-800 fw-bold">
                                Practitioner
                              </span>
                              <span className="fs-10 text-600">
                                {item.pract_name}
                              </span>
                            </div>
                          </Col>
                          <Col xs={6} md={2}>
                            <div className="d-flex flex-column">
                              <span className="fs-10 text-800 fw-bold">
                                Is Maternity
                              </span>
                              <span className="fs-10 text-600">
                                {item.matrnty ? "Yes" : "No"}
                              </span>
                            </div>
                          </Col>
                          {item.bodysite && (
                            <Col xs={6} md={2}>
                              <div className="d-flex flex-column">
                                <span className="fs-10 text-800 fw-bold">
                                  Body Site
                                </span>
                                <span className="fs-10 text-600">
                                  {item.bodysitedesc}
                                </span>
                              </div>
                            </Col>
                          )}
                          {item.subsite && (
                            <Col xs={6} md={2}>
                              <div className="d-flex flex-column">
                                <span className="fs-10 text-800 fw-bold">
                                  Sub Site
                                </span>
                                <span className="fs-10 text-600">
                                  {item.subsitedesc}
                                </span>
                              </div>
                            </Col>
                          )}
                          {hasPrescriptionDetails && (
                            <div className="fs-9 text-success fw-bold mb-2 border-bottom py-2">
                              Prescription Details
                            </div>
                          )}
                          {medCode && (
                            <Col xs={6} md={2}>
                              <div className="d-flex  flex-column">
                                <span className="fs-10 text-info fw-bold">
                                  Prescribed Medication Code
                                </span>
                                <span className="fs-10 text-info-emphasis">
                                  {medCode}
                                </span>
                              </div>
                            </Col>
                          )}
                          {medDesc && (
                            <Col xs={6} md={2}>
                              <div className="d-flex flex-column">
                                <span className="fs-10 text-info fw-bold">
                                  Prescribed Medication Desc.
                                </span>
                                <span className="fs-10 text-info-emphasis">
                                  {medDesc}
                                </span>
                              </div>
                            </Col>
                          )}
                          {strength && (
                            <Col xs={6} md={2}>
                              <div className="d-flex flex-column">
                                <span className="fs-10 text-info fw-bold">
                                  Strength
                                </span>
                                <span className="fs-10 text-info-emphasis">
                                  {strength}
                                </span>
                              </div>
                            </Col>
                          )}
                          {absenceCode && (
                            <Col xs={6} md={2}>
                              <div className="d-flex flex-column">
                                <span className="fs-10 text-info fw-bold">
                                  Absence Reason
                                </span>
                                <span className="fs-10 text-capitalize text-info-emphasis">
                                  {absenceCode}
                                  {absenceOther && (
                                    <div>({absenceOther})</div>
                                  )}
                                </span>
                              </div>
                            </Col>
                          )}

                          {selectionReason && (
                            <Col xs={6} md={2}>
                              <div className="d-flex flex-column">
                                <span className="fs-10 text-info fw-bold">
                                  Selection Reason
                                </span>
                                <span className="fs-10 text-info-emphasis">
                                  {selectionReason}
                                </span>
                              </div>
                            </Col>
                          )}
                          {pharmacistSub && (
                            <Col xs={6} md={2}>
                              <div className="d-flex flex-column">
                                <span className="fs-10 text-info fw-bold">
                                  Pharmacist Substitute
                                </span>
                                <div className="d-flex flex-column">
                                  <span className="fs-10 text-info-emphasis">
                                    {pharmacistSub}
                                  </span>
                                  {pharmacistSubReason && (
                                    <span className="fs-10 text-info-emphasis">
                                      ({pharmacistSubReason})
                                    </span>
                                  )}
                                </div>
                              </div>
                            </Col>
                          )}

                          {periodDisplay && (
                            <Col xs={6} md={2}>
                              <div className="d-flex flex-column">
                                <span className="fs-10 text-info fw-bold">
                                  Period
                                </span>
                                <span className="fs-10 text-info-emphasis">
                                  {periodDisplay}
                                </span>
                              </div>
                            </Col>
                          )}
                          {durationDisplay && (
                            <Col xs={6} md={2}>
                              <div className="d-flex flex-column">
                                <span className="fs-10 text-info fw-bold">
                                  Duration
                                </span>
                                <span className="fs-10 text-info-emphasis">
                                  {durationDisplay}
                                </span>
                              </div>
                            </Col>
                          )}
                          {frequencyDisplay && (
                            <Col xs={6} md={2}>
                              <div className="d-flex flex-column">
                                <span className="fs-10 text-info fw-bold">
                                  Frequency
                                </span>
                                <span className="fs-10 text-info-emphasis">
                                  {frequencyDisplay}
                                </span>
                              </div>
                            </Col>
                          )}
                          {doseDisplay && (
                            <Col xs={6} md={2}>
                              <div className="d-flex flex-column">
                                <span className="fs-10 text-info fw-bold">
                                  Dose
                                </span>
                                <span className="fs-10 text-info-emphasis">
                                  {doseDisplay}
                                </span>
                              </div>
                            </Col>
                          )}
                          {routeDisplay && (
                            <Col xs={6} md={2}>
                              <div className="d-flex flex-column">
                                <span className="fs-10 text-info fw-bold">
                                  Route
                                </span>
                                <span className="fs-10 text-info-emphasis">
                                  {routeDisplay}
                                </span>
                              </div>
                            </Col>
                          )}
                          {timeInstDisplay && (
                            <Col xs={6} md={2}>
                              <div className="d-flex flex-column">
                                <span className="fs-10 text-info fw-bold">
                                  Time Instruction
                                </span>
                                <span className="fs-10 text-info-emphasis">
                                  {timeInstDisplay}
                                </span>
                              </div>
                            </Col>
                          )}
                          {refillDisplay && (
                            <Col xs={6} md={2}>
                              <div className="d-flex flex-column">
                                <span className="fs-10 text-info fw-bold">
                                  Refill
                                </span>
                                <span className="fs-10 text-info-emphasis">
                                  {refillDisplay}
                                </span>
                              </div>
                            </Col>
                          )}
                          {dosageInstDisplay && (
                            <Col xs={6} md={2}>
                              <div className="d-flex flex-column">
                                <span className="fs-10 text-info fw-bold">
                                  Dosage Instruction
                                </span>
                                <span className="fs-10 text-info-emphasis">
                                  {dosageInstDisplay}
                                </span>
                              </div>
                            </Col>
                          )}
                          {patientInstDisplay && (
                            <Col xs={6} md={2}>
                              <div className="d-flex flex-column">
                                <span className="fs-10 text-info fw-bold">
                                  Patient Instruction
                                </span>
                                <span className="fs-10 text-info-emphasis">
                                  {patientInstDisplay}
                                </span>
                              </div>
                            </Col>
                          )}
                        </Row>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Card>
            </Col>
          );
        })}

        {/* Totals Card */}
        {claimServicesList.length > 0 && (
          <Col xs={12} className="mt-3">
            <Card className="p-3">
              <Row className="text-center text-md-start">
                <Col xs={12} md={4}>
                  <div className="fw-bold fs-10 text-800 mb-2">
                    Total Net Amount
                  </div>
                  <div className="fs-10 text-primary fw-bold">
                    {claimServicesList
                      .reduce((sum, s) => sum + parseFloat(s.servinfo_prdnamnt || 0), 0)
                      .toFixed(2)}{" "}
                    SAR
                  </div>
                </Col>
                <Col xs={12} md={4}>
                  <div className="fw-bold fs-10 text-800 mb-2">
                    Total Patient Share
                  </div>
                  <div className="fs-10 text-primary fw-bold">
                    {claimServicesList
                      .reduce((sum, s) => sum + parseFloat(s.servinfo_prdpshre || 0), 0)
                      .toFixed(2)}{" "}
                    SAR
                  </div>
                </Col>
                <Col xs={12} md={4}>
                  <div className="fw-bold fs-10 text-800 mb-2">Total VAT</div>
                  <div className="fs-10 text-success fw-bold">
                    {claimServicesList
                      .reduce((sum, s) => {
                        const netAmount = parseFloat(s.servinfo_prdnamnt || 0);
                        const vatPercentage = parseFloat(s.servinfo_prdtax || 0);
                        // Calculate VAT: VAT = netAmount * (vatPercentage / (100 + vatPercentage))
                        // This extracts VAT from the net amount which includes VAT
                        const vatAmount =
                          vatPercentage > 0
                            ? netAmount *
                            (vatPercentage / (100 + vatPercentage))
                            : 0;
                        return sum + vatAmount;
                      }, 0)
                      .toFixed(2)}{" "}
                    SAR
                  </div>
                </Col>
              </Row>
            </Card>
          </Col>
        )}
      </Row>
    </motion.div>
  );
};

export default ClaimProviderServices;
